import React from 'react';

import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { MobileServerSettingsSubspaceState } from '~src/settings/components/subspaces/ServerSettingsSpace/mobile/MobileServerSettingsSpace';
import { coordinatorSubmitFailedHandler,coordinatorSubmitHandler } from '~src/settings/general-settings/components/common/GeneralToastHandlers';
import { ISiteAdminSettings, ISiteSubscriptionSettings } from '~src/settings/types/ISiteSettingsForSiteAdmin';
import { Sites } from '~src/siteManagement/services/resources/Sites';

import { SettingsFormikContainer } from '../../components/common/SettingsFormikContainer';
import { MobileSecuritySettingsService } from '../MobileSecuritySettingsShared';
import { MobileSecuritySettingsTelemetrySettingLocation, sendUpdateMobileSecuritySettingsTelemetry } from '../MobileSecuritySettingsTelemetry';

export type MobileServerSettingsSubFormikProps = {
  settings: MobileServerSettingsSubspaceState;
}

export function MobileServerSettingsCoordinator(props: MobileServerSettingsSubspaceState) {
  let sections = Array<string>();
  if (!props.doesTheServerHaveMoreThanOneSite) {
    sections.push('MobileGeneralSettingsSection');
  }
  sections.push('MobileSecuritySettingsSection');

  return (
    <SettingsCoordinator
      onSubmit={coordinatorSubmitHandler}
      onSubmitFailure={coordinatorSubmitFailedHandler}
      submitSequentially = {true}>

      <SettingsFormikContainer
        formName={'ReactMobileServerSettings'}
        settings={props}
        sections={sections}
        onSubmit={useSubmitHandler(props)}
      >
      </SettingsFormikContainer>

    </SettingsCoordinator>
  );
}

function useSubmitHandler(settings: MobileServerSettingsSubspaceState) {
  return React.useCallback(
    async (settings: MobileServerSettingsSubspaceState) => {
      let functions = Array<Promise<IResult>>();
      if (settings.siteSettingsForSiteAdmin !== undefined) {
        const siteId = (settings.siteSettingsForSiteAdmin as any).id || settings.siteSettingsForSiteAdmin.siteId;
        const newSiteAdminSettings = settings.siteSettingsForSiteAdmin.siteAdminSettings as ISiteAdminSettings;
        const subscriptionSettings = settings.siteSettingsForSiteAdmin.subscriptionSettings as ISiteSubscriptionSettings;
        functions.push(Sites.instance.updateSiteSettingsForSiteAdmin(siteId, newSiteAdminSettings, subscriptionSettings));
      }

      sendUpdateMobileSecuritySettingsTelemetry(settings.mobileSecuritySettings, MobileSecuritySettingsTelemetrySettingLocation.server_settings);
      functions.push(MobileSecuritySettingsService.setMobileSecuritySettingsForServer(settings.mobileSecuritySettings));
      await Promise.all(functions);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [settings]
  );
}
